import {
  nfp66a,
  digitalStation,
  workpieceDisplayArea,
  uv650Flexcell,
  nfx400a_,
  digitalTwinExperience,
  video_,
} from "./imgIconConfig.js";

const timtosConfig = [
  { top: "14%", left: "27%", src: nfp66a, card: ["machine", "NFP66A"] },
  {
    top: "21%",
    left: "72%",
    src: digitalStation,
    card: ["smartManufacturing", "SMObjectives"],
  },
  {
    top: "32%",
    left: "30%",
    src: workpieceDisplayArea,
  },
  {
    top: "37%",
    left: "11%",
    src: uv650Flexcell,
    card: ["machine", "UV650"],
  },
  { top: "40%", left: "73%", src: nfx400a_, card: ["machine", "NFX400AMPS"] },
  {
    top: "75%",
    left: "60%",
    src: digitalTwinExperience,
  },
  { top: "80%", left: "90%", src: video_ },
];

export { timtosConfig };
